export const SOLD_SUBSCRIPTION_PAYNL_PAYMENT_ERROR_MESSAGE = {
    NOT_ACTIVATED_BY_SUCCESSFUL_DIRECT_DEBIT: 'This mandateId is not activated by a successful direct debit.',
    SUBMITTING: 'Submitting',
};
